var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Container',{staticClass:"product-carousel",attrs:{"data-external":"product-carousel"}},[_c('CardSection',{attrs:{"title":_vm.title,"description":_vm.description,"link":_vm.computedLink,"link-text":_vm.computedLinkText,"mobile":{
      cardMode: 'scroll',
      cardFlexBasis: '236px',
      showDescription: false,
      showSteppers: false,
    },"tablet":{
      cardFlexBasis: 'calc(100% / 3)',
      showDescription: true,
      showSteppers: true,
    },"desktop":{
      cardFlexBasis: '25%',
    }}},_vm._l((_vm.filteredProducts),function(product,i){return _c('ProductCard',{key:i,attrs:{"product":_vm.mapProductToCard(product),"size":"compact"}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }